import type { ReactNode } from "react";
import type { ProductDetail } from "./types";
import { ListingGuestQuoteRequest } from "./listing-guest-quote-request";
import { ListingRecycleSignInGate } from "./listing-recycle-sign-in-gate";

export type GateAction = "quote" | "checkout";

export function SignedOutListingAction({
  data,
  preview,
  children,
}: {
  data: ProductDetail;
  preview?: GateAction;
  children?: ReactNode;
}) {
  if (data.intent === "recycle") return <ListingRecycleSignInGate data={data} />;
  if (preview === "quote" || !data.checkoutEnabled) {
    return <ListingGuestQuoteRequest data={data} />;
  }
  return <>{children}</>;
}
